import { createAction } from 'redux-actions';

export const resetFormEvent = createAction('RESET_RESERVATION_FORM_EVENT');
